// import { BsGlobe, BsMegaphone, BsRobot, BsArrowRight } from "react-icons/bs";

// function Services() {
//   const services = [
//     {
//       icon: <BsGlobe />,
//       title: "Website Development",
//       description:
//         "High-performance websites designed to attract visitors, build trust and generate qualified leads.",
//     },
//     {
//       icon: <BsMegaphone />,
//       title: "Social Media Marketing",
//       description:
//         "Strategic campaigns that increase visibility, engagement and customer acquisition.",
//     },
//     {
//       icon: <BsRobot />,
//       title: "AI Automation",
//       description:
//         "Automate repetitive work, improve response times and scale operations efficiently.",
//     },
//   ];

//   return (
//     <section id="services" className="services-section">
//       <div className="container">
//         <div className="section-title">
//           <span className="section-subtitle">WHAT WE DO</span>

//           <h2>Solutions Designed To Grow Your Business</h2>
//         </div>

//         <div className="service-row">
//           <div className="service-number">01</div>

//           <div className="service-content">
//             <h3>Website Development</h3>

//             <p>
//               High-performance websites designed to attract visitors, build
//               trust and generate qualified leads.
//             </p>
//           </div>
//         </div>

//         <div className="service-row">
//           <div className="service-number">02</div>

//           <div className="service-content">
//             <h3>Social Media Marketing</h3>

//             <p>
//               Strategic campaigns that increase visibility, engagement and
//               customer acquisition.
//             </p>
//           </div>
//         </div>

//         <div className="service-row">
//           <div className="service-number">03</div>

//           <div className="service-content">
//             <h3>AI Automation</h3>

//             <p>
//               Automate repetitive work, improve response times and scale
//               operations.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default Services;

import { BsGlobe, BsMegaphone, BsRobot } from "react-icons/bs";

function Services() {
  const services = [
    {
      number: "01",
      title: "Website Development",
      description:
        "High-performance websites designed to attract visitors, build trust and generate qualified leads.",
    },
    {
      number: "02",
      title: "Social Media Marketing",
      description:
        "Strategic campaigns that increase visibility, engagement and customer acquisition.",
    },
    {
      number: "03",
      title: "AI Automation",
      description:
        "Automate repetitive work, improve response times and scale operations efficiently.",
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">WHAT WE DO</span>
          <h2>Solutions Designed To Grow Your Business</h2>
        </div>

        <div className="services-grid">
          {services.map((item, index) => (
            <div key={index} className="service-card">
              <div className="service-number">{item.number}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
